// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.proweb-info-banner[data-v-ec1eb768] {\n  width: calc(100% - 30px);\n  margin: 15px auto 0;\n}\n.proweb-info-banner__btn[data-v-ec1eb768] {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  width: auto;\n  margin-left: auto;\n  padding: 0 15px;\n}\n@media (max-width: 767px) {\n.proweb-info-banner[data-v-ec1eb768] {\n    width: 100%;\n}\n}\n@media (max-width: 550px) {\n.proweb-info-banner__btn[data-v-ec1eb768] {\n    margin: 10px 0 0;\n}\n}\n", ""]);
// Exports
module.exports = exports;
